var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedEnj0)",
    d: "M16.613 15.429h-5.8c-1.358-.003-2.28-.968-2.826-2.143h8.75c.718 0 1.263-.59 1.263-1.286s-.545-1.286-1.262-1.286H7.87c.428-1.168 1.65-2.144 2.943-2.143h5.8c.716 0 1.262-.547 1.262-1.237c0-.695-.552-1.334-1.262-1.334h-5.8c-3.133 0-5.67 2.696-5.67 6v.18a6.17 6.17 0 0 0 1.72 4.122c1.058 1.086 2.475 1.695 3.95 1.698h5.8c.717 0 1.262-.639 1.262-1.334s-.545-1.237-1.262-1.237"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedEnj0",
    x1: 17.41,
    x2: 8.32,
    y1: 15.093,
    y2: 6.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9468FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADF8FF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnj);
export default __webpack_public_path__ + "static/media/enj.f6eb8528cfab6af28b8ab997a9980e1e.svg";
export { ForwardRef as ReactComponent };